

















































































































































































import Vue from 'vue'
import * as _ from 'lodash'
import dayjs from 'dayjs'
import RemoteConfig from './RemoteConfig.vue'
import {extranetType, extranetRecordColumns} from '../data'
import moment from 'moment'
import GatewayConfig from './GatewayConfig.vue'
import DeviceSetting from './DeviceSetting.vue'
import {
  ExtranetConfigServiceProxy,
  ExtranetServiceProxy,
  BeginExtranetDTO,
  CloseExtranetDTO,
  ConnectionRecordServiceProxy,
  ExtranetParamSettingServiceProxy,
  GatewayConfigDataDTO,
  QueryExportDataVO,
  FindDeviceStateListDto, DeviceServiceProxy
} from '@/service-proxies/app-v2/iot-extranet.service-proxies'
import { createExtranetVersionService } from './../ExtranetVersionService'

const esp = new ExtranetServiceProxy()
const ecsp = new ExtranetConfigServiceProxy()
const connectionRecordProxy = new ConnectionRecordServiceProxy()
const paramSettingProxy = new ExtranetParamSettingServiceProxy()
const deviceServProxy = new DeviceServiceProxy()

export default Vue.extend({
  name: 'DeviceTab',
  provide: function(){
    return {
      device: this
    }
  },
  components: {RemoteConfig, GatewayConfig, DeviceSetting},
  props: {
    device: {
      type: Object,
      default: null
    },
    virtualLinkMsgList: {
      type: Array,
      default: () => []
    },
    comPortsList: {
      type: Array,
      default: () => []
    },
    extranetSocketConfig: {
      type: Object,
      default: () => ({})
    },
    versionService:{
      type: Object,
      default:()=>{
        return createExtranetVersionService()
      }
    }
  },
  data() {
    return {
      tabIndex: '4',
      isShowDiagnsis: false, // 是否显示诊断信息
      isfoldCode: true, // 是否隐藏诊断码
      newCode: '',
      expiryTimeType: 'B', // 到期类型
      expiryTime: null, // 到期时间
      configList: [], // 配置
      configLoadingStatus: false,
      dataList: [], // 记录
      recordParam: {
        current: 1,
        size: 10
      },
      totalRecord: 0,
      extranetType,
      extranetRecordColumns,
      form: this.$form.createForm(this),
      confirmLoading: false,
      showEndExtranetModal: false,
      addExtranetRecordForm: {
        faultDesc: '',
        handleOpinion: '',
        diagnosticPerson: ''
      },
      initData: {},
      visible: false,
      showModal : false,
      modalContent:null,
      extranetSetting:{},
      runningAnimation: false,
      deviceStateList:[]
      // isHaveGatewayCode:false,
      // isHaveRemoteNetworkIp:false
    }
  },
  watch: {
    device: {
      handler(device) {
        if (device.id) {
          // tab1状态重置
          this.tabIndex = '4'
          this.isfoldCode = true
          this.isShowDiagnsis = false
          const code = this.device.extranetCode ? this.device.extranetCode : ''
          this.newCode = code ? code.substr(0, 2) + '***' + code.substr(-1, 1) : ''
          this.device.expireTime = !this.device.expiredDate
              ? this.$t('indefinite')
              : dayjs(this.device.expiredDate).format('YYYY-MM-DD')
          this.expiryTimeType = 'B'
          this.expiryTime = dayjs()
              .add(1, 'day')
              .format('YYYY-MM-DD 23:59:59')
          this.queryExtranet() // 查询配置信息
          // tab3状态重置
          this.loadRecord() // 查询记录
          this.runningAnimation = this.device.userVisibleStatus===2;
        } else {
          this.configList = []
          this.dataList = []
          this.totalRecord = 0
          this.expiryTime = null
          this.newCode = ''
          this.runningAnimation = false;
        }
      },
      deep: true,
      immediate: true,
    },
    isfoldCode: {
      handler(isfoldCode) {
        if (isfoldCode) {
          this.newCode = this.device.extranetCode
              ? this.device.extranetCode.substr(0, 2) + '***' + this.device.extranetCode.substr(-1, 1)
              : ''
        } else {
          this.newCode = this.device.extranetCode
        }
      },
      immediate: true
    },
    virtualLinkMsgList: {
      handler(virtualLinkMsgList) {
        this.configList.map((config) => {
          if (virtualLinkMsgList.length) {
            virtualLinkMsgList.map((item) => {
              if (config.virtualIp === item.ip && config.virtualPort === item.port) {
                config.status = item.status // 0:disconnect; 1:connected
              }
            })
          } else {
            config.status = false
          }
        })
      },
      deep: true
    },
    expiryTimeType(val) {
      if (val === 'B') {
        this.expiryTime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      }
    },

  },
  created() {
    document.addEventListener('copy', (e) => {
      this.eventListenerCopy(e)
    })
  },
  destroyed() {
    document.removeEventListener('copy', (e) => {
      const value = window.getSelection().toString()
      if (!value) {
        return
      }
      e.clipboardData.setData('text/plain', value)
      e.preventDefault()
    })
  },
  computed: {
    canConnect() {
      return this.device.userVisibleStatus == 1 ;
    },
    isWorking(): boolean {
      return this.extranetSocketConfig &&
          this.extranetSocketConfig.diagnosising === 'Working';
    },

  },
  mounted() {
    paramSettingProxy.getCurrentExtranetParamSetting()
        .then(res=>{
          this.extranetSetting={
            max: res.max,
            editEnable: res.editEnable,
            deleteEnable: res.deleteEnable
          }
        })
  },
  beforeDestroy(){
  },
  methods: {
    // 显示隐藏诊断码
    toggleCode() {
      // 6位诊断码，隐藏3-5位：12***6
      this.isfoldCode = !this.isfoldCode
    },
    chooseTimeType(value) {
      if (value === 'B') {
        // 有期限，选择具体日期时间
        this.expiryTimeType = 'B'
      } else {
        // 无期限
        this.expiryTime = null
      }
    },
    disabledStartDate(expiryTime) {
      if (!expiryTime) {
        return false
      }
      return expiryTime.valueOf() < new Date().valueOf()
    },
    changeTimeType(time) {
      this.expiryTime = dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    // 生成指定设备的远程诊断码
    createExtranetCode() {

      if (this.isWorking) {
        this.$confirm({
          content: '当前已有一台设备在连接中',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
          }
        });
        return;
      }

      if (!this.device.id) {
        return
      }
      let id: string = this.device.id
      let expireTime: any
      console.log(this.expiryTimeType)
      if (this.expiryTimeType === 'A') {
        expireTime = null
      } else {
        if (this.expiryTime) {
          expireTime = dayjs(this.expiryTime).format('YYYY-MM-DD HH:mm:ss')
        } else {
          expireTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
        }
      }
      let workStationId: any = []
      workStationId.push(id)
      const params = {
        workStationIds: workStationId,
        expireTime: expireTime
      }

      esp.beginExtranet(new BeginExtranetDTO(params)).then((res) => {
        if (res) {
          this.$emit('getDeviceInfo')
          this.$emit('beginServer')
          this.loadRecord()
        }
      })
    },
    // 开始连接
    startExtranetCode() {

      if(this.versionService.needUpdate){
        this.$confirm({
            content: `发现新版本:${this.versionService.newVersion},点击确认下载!`,
            onOk:()=>{
              window.open(this.versionService.downloadUrl);
            },
            cancelText: '取消',
          });
        return;
      }

      const input = new BeginExtranetDTO();
      input.expireTime = dayjs(this.expiryTime).format('YYYY-MM-DD HH:mm:ss');
      input.workStationIds = [this.device.id];

      esp.beginExtranet(new BeginExtranetDTO(input)).then((res) => {
        if (res) {
          const beginParam = {
            extranetCode: res.extranetCode,
            sessionId: res.sessionId,
            gatewayIdList : [this.device.gatewayId]
          }
          this.$emit('getDeviceInfo', 'showCode')
          this.$emit('beginServer', beginParam)
        }
        this.changeConnectStates()
      })
    },
    // 停止诊断
    stopDiagnose(id) {

      this.$emit('stopConnect', this.device.extranetCode)
      return esp.closeExtranet(new CloseExtranetDTO({
        gatewayCode: this.device.gatewayCode,
        sessionId: id,
        gatewayId: this.device.gatewayId
      })).then((res) => {
        this.$emit('getDeviceInfo')
        this.loadRecord();
      })
    },
    eventListenerCopy(e) {
      const value = window.getSelection().toString()
      if (!value) {
        if (!this.device.extranetCode) {
          return
        }
        e.clipboardData.setData('text/plain', this.device.extranetCode)
        e.preventDefault()
        return
      } else {
        e.clipboardData.setData('text/plain', value)
        e.preventDefault()
      }
    },
    // 拷贝诊断码
    copy() {
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success(this.$t('page_my_document_copysuccess') + '！')
    },
    loadRecord(pagination) {
      this.recordParam.current = pagination ? pagination.current : 1
      this.getRecordList()
    },
    // 查询诊断记录
    getRecordList() {
      const params: any = {deviceId: this.device.id, pageRequestDTO: {...this.recordParam}}

      connectionRecordProxy.getPage(params)
          .then((res) => {
            if (!res.items) {
              return;
            }
            this.dataList = res.items;
            this.totalRecord = res.totalCount;
          })

    },
    // 查询设备配置信息
    queryExtranet() {
      if (!this.device.id) {
        return
      }
      /*
      this.configLoadingStatus = true

      ecsp
          .getDeviceConfigList(this.device.id)
          .then((res) => {

            this.configList = []
            this.configList.push(...res)
          })
          .finally(() => {
            this.configLoadingStatus = false
          })
          */
    },
    // 配置信息的增删改操作处理
    handleConfigAction(data) {
      if (data.type) {
        if (data.type === 'add') {
          this.addExtranet(data.data)
        } else {
          this.updateExtranet(data.data)
        }
      } else {
        // 删除
        this.deleteExtranet(data)
      }
    },
    // 添加配置信息
    async addExtranet(data) {
      //const params = _.cloneDeep(data);
      //params.workStationId = this.device.id
      //await ecsp.saveDeviceConfig(params);
      //this.queryExtranet()
    },
    // 修改配置信息
    async updateExtranet(data) {
      //const params = _.cloneDeep(data)
      
      //params.workStationId = this.device.id
      //await ecsp.saveDeviceConfig(params)
      //this.queryExtranet()
    },
    // 删除配置信息
    async deleteExtranet(id) {
      
      // await ecsp.clearDeviceConfig(id)
      //await ecsp.deleteDeviceConfig(id);
      //this.queryExtranet()
    },
    // 确认断开链路
    handleOk() {
      this.confirmLoading = true
      const param = Object.assign({}, this.addExtranetRecordForm, {workStationId: this.device.id})
      connectionRecordProxy.addRecord(param).then(res => {
        this.addExtranetRecordForm = {
          faultDesc: '',
          handleOpinion: '',
          diagnosticPerson: ''
        }
        return this.stopDiagnose(this.device.sessionId);
      })
          .finally(() => {
            this.confirmLoading = false
            this.showEndExtranetModal = false
          })
    },
    closeHander() {
      this.stopDiagnose(this.device.sessionId)
    },
    handleCancel() {
      this.showEndExtranetModal = false
    },
    showDrawer() {
      this.$refs.deviceSetting.showDrawer();
      /*
      if(!this.$refs.deviceSetting.isHaveRemoteNetworkIp){
        this.showModal = true
      }else{
        this.$refs.deviceSetting.showDrawer()
      }
      */
    },
    handleOkModal() {
      // this.showSaveModal = false
      // this.showModal = false;
    },
    changeConnectStates(){
      this.$emit("refreshDeviceState")
    }

  },

})
